<template>
  <aside class="c-headerPublisher" :class="styleAside">
    <slot name="caption"></slot>
    <slot name="link"></slot>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      isAuthenticated: state => state.account.authenticated,
    }),

    styleAside() {
      return this.isAuthenticated ? 'c-headerPublisher--hidden' : ''
    }
  },
}
</script>

<style lang="scss">
@import "~css/_references";

.c-headerPublisher {
  background: $v-colorGray-dark-1;
  height: 50px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  &--hidden {
    display: none;
  }

  &_caption {
    color: rgba($v-colorWhite, .75);
    text-align: right;
    font-size: 10px;
    margin-right: $v-gap-xs;

    @include f-media('>tablet') {
      font-size: 12px;
    }
  }

  &_logo {
    width: 111px;
    height: 25px;
    margin-right: auto;

    @include f-media('>tablet') {
      width: 130px;
      height: 30px;
    }
  }
}

</style>